import { CultureInfo } from '../culture-info.model';
import { CultureInfoSo } from './so';

/**
 * @ignore
 */
export const CultureInfoSoDJ: CultureInfo = {
  name: 'so-DJ',
  displayName: 'Soomaali (Jabuuti)',
  iso3LanguageCode: 'som',
  iso2LanguageCode: 'so',
  ietfLanguageTag: 'so-DJ',
  parent: CultureInfoSo
};
